<app-background-image data-state="sustainability"></app-background-image>
<app-topbar></app-topbar>


<app-sidebar class="d-print-none">
    <div class="sidebar-header"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block" (click)="back()">
                <fa-icon [icon]="faBack"></fa-icon>
                <span style="padding-left: 10px">Back</span>
            </button>
        </li>
    </ul>
</app-sidebar>
<ng-container>
    <div class="main-content">
        <form (ngSubmit)="onSubmit()" autocomplete="off">
            <app-card headline="Edit Co2 Consumption">
                <app-card-body style="padding: 20px">
                    <table
                        class="form-table"
                        [formGroup]="editCo2ConsumptionFormGroup"
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <label for="portCrane"
                                        >Port Crane<span>*</span></label
                                    >
                                </td>
                                <td>
                                    <div>
                                        <input
                                            type="number"
                                            id="portCrane"
                                            formControlName="portCrane"
                                            class="form-control"
                                            aria-describedby="portCraneFormular"
                                            [ngClass]="{
                                                'is-invalid':
                                                    (portCraneControl.touched ||
                                                        portCraneControl.dirty) &&
                                                    !portCraneControl.valid,
                                                'is-valid':
                                                    portCraneControl.valid
                                            }"
                                        /><span>Kg Co2 per hour</span>
                                    </div>
                                    <small
                                        id="portCraneFormular"
                                        class="form-text text-muted"
                                        >Formula: (({{portCraneControl.value}} kg) * Total operation hours) - (Pause + Waiting time + Pause day)</small
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label for="mobileCrane"
                                        >Mobile Crane<span>*</span></label
                                    >
                                </td>
                                <td>
                                    <div>
                                        <input
                                            type="number"
                                            id="mobileCrane"
                                            formControlName="mobileCrane"
                                            class="form-control"
                                            aria-describedby="mobileCraneFormular"
                                            [ngClass]="{
                                                'is-invalid':
                                                    (mobileCraneControl.touched ||
                                                        mobileCraneControl.dirty) &&
                                                    !mobileCraneControl.valid,
                                                'is-valid':
                                                    mobileCraneControl.valid
                                            }"
                                        /><span>Kg Co2 per hour</span>
                                    </div>
                                    <small
                                        id="mobileCraneFormular"
                                        class="form-text text-muted"
                                        >Formula: (({{mobileCraneControl.value}} kg) * Total operation hours) - (Pause + Waiting time + Pause day)</small
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label for="vesselCrane"
                                        >Vessel Crane<span>*</span></label
                                    >
                                </td>
                                <td>
                                    <div>
                                        <input
                                            type="number"
                                            id="vesselCrane"
                                            formControlName="vesselCrane"
                                            class="form-control"
                                            aria-describedby="vesselCraneFormular"
                                            [ngClass]="{
                                                'is-invalid':
                                                    (vesselCraneControl.touched ||
                                                        vesselCraneControl.dirty) &&
                                                    !vesselCraneControl.valid,
                                                'is-valid':
                                                    vesselCraneControl.valid
                                            }"
                                        /><span>Kg Co2 per hour</span>
                                    </div>
                                    <small
                                        id="vesselCraneFormular"
                                        class="form-text text-muted"
                                        >Formula: (({{vesselCraneControl.value}} kg) * Total operation hours) - (Pause + Waiting time + Pause day)</small
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label for="vesselPower"
                                        >Vessel Power<span>*</span></label
                                    >
                                </td>
                                <td>
                                    <div>
                                        <input
                                            type="number"
                                            id="vesselPower"
                                            aria-describedby="vesselPowerFormular"
                                            formControlName="vesselPower"
                                            class="form-control"
                                            [ngClass]="{
                                                'is-invalid':
                                                    (vesselPowerControl.touched ||
                                                        vesselPowerControl.dirty) &&
                                                    !vesselPowerControl.valid,
                                                'is-valid':
                                                    vesselPowerControl.valid
                                            }"
                                        /><span>Kg Co2 per hour</span>
                                    </div>
                                    <small
                                        id="vesselPowerFormular"
                                        class="form-text text-muted"
                                        >Formula: ({{vesselPowerControl.value}} kg) * (Ship GT) * (Total At Berth Hours)</small
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label for="shorePower"
                                        >Shore Power<span>*</span></label
                                    >
                                </td>
                                <td>
                                    <div>
                                        <input
                                            type="number"
                                            id="shorePower"
                                            aria-describedby="shorePowerFormular"
                                            formControlName="shorePower"
                                            class="form-control"
                                            [ngClass]="{
                                                'is-invalid':
                                                    (shorePowerControl.touched ||
                                                        shorePowerControl.dirty) &&
                                                    !shorePowerControl.valid,
                                                'is-valid':
                                                    shorePowerControl.valid
                                            }"
                                        /><span>Kg Co2 per hour</span>
                                    </div>
                                    <small
                                        id="shorePowerFormular"
                                        class="form-text text-muted"
                                        >({{shorePowerControl.value}} kg) * (Ship GT) * (Total At Berth Hours)</small
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </app-card-body>
                <app-card-footer>
                    <div class="btn-group float-right">
                        <button
                            class="btn btn-primary"
                            [disabled]="!editCo2ConsumptionFormGroup.valid"
                        >
                            Update
                        </button>
                    </div>
                </app-card-footer>
            </app-card>
        </form>
    </div>
</ng-container>
